import React from 'react';

interface ActionButtonsProps {
  hasTimezones: boolean;
  onAddTimezone: () => void;
  onReset: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ hasTimezones, onAddTimezone, onReset }) => {
  return (
    <div className="row mt-4">
      <div className="col d-flex justify-content-start">
        <button
          className={`btn ${hasTimezones ? 'btn-outline-primary' : 'btn-primary'} mr-2`}
          onClick={onAddTimezone}
        >
          Add Timezone
        </button>
        <button className="btn btn-outline-danger" onClick={onReset}>
          Reset
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
